import { render, staticRenderFns } from "./portal-card-navigation-bar.vue?vue&type=template&id=6e67e0a4&"
import script from "./portal-card-navigation-bar.vue?vue&type=script&lang=ts&"
export * from "./portal-card-navigation-bar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports